import { Card, Stack, Typography, Chip } from "@mui/material";
import { fCurrency } from "../../../../utils/formatNumber";

// ----------------------------------------------------------------------

interface Props {
  stats: any;
}

// ----------------------------------------------------------------------

export default function BusinessHealthSummary({ stats }: Props) {
  const netProfit = stats?.netProfit || 0;
  const totalIncome = stats?.totalIncome || 0;
  const totalExpenditure = stats?.totalExpenditure || 0;
  const totalTransactions = stats?.totalTransactions || 0;
  const reconciledCount = stats?.reconciledCount || 0;
  const unclassifiedCount = stats?.unclassifiedCount ?? 0;
  
  const isHealthy = netProfit > 0;
  const profitMargin =
    totalIncome > 0 ? (netProfit / totalIncome) * 100 : 0;
  const reconciliationProgress =
  totalTransactions > 0
    ? (reconciledCount / totalTransactions) * 100
    : 0;
  return (
    <Card sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Typography variant="h6">
          Business Health Summary
        </Typography>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Business Status
          </Typography>
          

          <Chip
            label={
            profitMargin >= 30
              ? "Excellent"
              : profitMargin >= 10
              ? "Healthy"
              : "Needs Attention"
          }
              color={
              profitMargin >= 30
                ? "success"
                : profitMargin >= 10
                ? "warning"
                : "error"
            }
            size="small"
          />
        </Stack>
                <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Total Income
          </Typography>

          <Typography variant="subtitle1">
            {fCurrency(totalIncome)}
          </Typography>
        </Stack>
                <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Total Expenditure
          </Typography>

          <Typography variant="subtitle1">
            {fCurrency(totalExpenditure)}
          </Typography>
        </Stack>
                <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Net Profit
          </Typography>

          <Typography
            variant="subtitle1"
            color={netProfit >= 0 ? "success.main" : "error.main"}
          >
            {fCurrency(netProfit)}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Profit Margin
          </Typography>

          <Typography variant="subtitle1">
            {profitMargin.toFixed(1)}%
          </Typography>
        </Stack>
                <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Reconciliation Progress
          </Typography>

          <Typography variant="subtitle1">
            {reconciliationProgress.toFixed(0)}%
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Total Transactions
          </Typography>

          <Typography variant="subtitle1">
            {totalTransactions}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            Unclassified Transactions
          </Typography>

          <Typography variant="subtitle1">
            {unclassifiedCount}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}